export const ActionName = {
  SHOW_MODAL: 'SHOW_MODAL',
  CLEAR_MODAL: 'CLEAR_MODAL',
}

export const Action = {
  ShowModal: ({ title, body, dismissable, onClose }) => ({ type: ActionName.SHOW_MODAL, payload: ({ title, body, dismissable, onClose }) }),
  ClearModal: () => ({ type: ActionName.CLEAR_MODAL, payload: null }),
}
